/* eslint-disable react/no-unescaped-entities */
import React from 'react';

function Release20250909() {
  return (
    <section className="flex flex-col gap-4 border-b">
      <h2 className="font-gothammedium text-neutral-700">Enrichment 25/26_S13 - S16</h2>
      <p className="-mt-4">09th September 2025</p>

      <h3 className="font-gothammedium text-neutral-700">
        ✅New Features & Improvements
      </h3>
      <ul className="-mt-4">
        <li>
          Product Types and Variants UI/API redesigns for better usability and
          data management:
          <ul className="ml-6 list-disc">
            <li>DT-13027</li>
            <li>DT-12992</li>
            <li>DT-12988</li>
            <li>DT-12987</li>
            <li>DT-12983</li>
          </ul>
        </li>
        <li>Maintenance Mode enabled for Feed config server migration: DT-13416</li>
        <li>
          Scheduled Maintenance Message Notification for 09/09/2025: DT-13840
        </li>
        <li>Size Mapping endpoint corrections in Swagger: DT-572</li>
      </ul>

      <h3 className="font-gothammedium text-neutral-700">🐞 Bug Fixes</h3>
      <ul className="-mt-4">
        <li>Fixed date validation issues in release date fields: DT-13712</li>
        <li>
          Bulk Operation names now display correctly in the completed section:
          DT-13675
        </li>
        <li>
          Margin threshold logic corrected for product enable/disable:
          <ul className="ml-6 list-disc">
            <li>DT-13279</li>
            <li>DT-13256</li>
            <li>DT-13255</li>
          </ul>
        </li>
        <li>PLP Export error ("503 service unavailable") resolved: DT-12786</li>
        <li>
          Fixed issues with Product Type attributes and Save button:
          <ul className="ml-6 list-disc">
            <li>DT-13450</li>
            <li>DT-13444</li>
            <li>DT-13442</li>
          </ul>
        </li>
      </ul>

      <h3 className="font-gothammedium text-neutral-700">🔧 Other Changes</h3>
      <ul className="-mt-4">
        <li>
          Improved logging and deployment scheduling:
          <ul className="ml-6 list-disc">
            <li>DT-12195</li>
            <li>DT-12194</li>
            <li>DT-12191</li>
            <li>DT-12187</li>
            <li>DT-12174</li>
            <li>DT-12163</li>
            <li>DT-12162</li>
            <li>DT-12161</li>
            <li>DT-12158</li>
            <li>DT-12155</li>
          </ul>
        </li>
        <li>
          User Management enhancements:
          <ul className="ml-6 list-disc">
            <li>DT-12505</li>
            <li>DT-12598</li>
          </ul>
        </li>
        <li>Indexer performance optimization: DT-11582</li>
      </ul>

      <h3 className="font-gothammedium text-neutral-700">
        🔹 Prism API & UI Enhancements
      </h3>
      <ul className="-mt-4">
        <li>Resolved:</li>
        <ul className="ml-6 list-disc">
          <li>Bulk operations slowness</li>
          <li>Attribute deletion issues</li>
          <li>UI refresh bugs</li>
        </ul>
        <li>Refined group admin permissions to prevent unintended access</li>
        <li>
          Improved release automation:
          <ul className="ml-6 list-disc">
            <li>Forced logouts during deployments</li>
            <li>Better release note tracking</li>
          </ul>
        </li>
      </ul>

      <h3 className="font-gothammedium text-neutral-700">
        🔹 Data Accuracy & API Improvements
      </h3>
      <ul className="-mt-4">
        <li>Fixed tax code and tax rate mismatches between DB and API</li>
        <li>Updated API documentation</li>
        <li>Implemented shared tokens for authentication</li>
        <li>Created new SKU and PLU endpoints in Prism B2B API</li>
      </ul>

      <h3 className="font-gothammedium text-neutral-700">
        🔹 User Management & Account Handling
      </h3>
      <ul className="-mt-4">
        <li>
          Enhanced user status handling (e.g., blocking users with pending
          requests over a week)
        </li>
        <li>
          Improved attribute definition visibility and transaction logs
        </li>
        <li>Fixed:</li>
        <ul className="ml-6 list-disc">
          <li>White screen errors in search filters</li>
          <li>Missing UI elements for disabled groups</li>
        </ul>
      </ul>

      <h3 className="font-gothammedium text-neutral-700">🔹 Testing & Support</h3>
      <ul className="-mt-4">
        <li>
          Multiple tickets focused on:
          <ul className="ml-6 list-disc">
            <li>E2E testing in UAT and Pre-Prod</li>
            <li>Stress testing of bulk operations</li>
            <li>Support for Q4 2024 configurations</li>
          </ul>
        </li>
      </ul>
    </section>
  );
}

export default Release20250909;
